// @flow
import React, { type Node } from 'react';
import classNames from 'classnames';

import Link from 'app/common/lib/link';

import HeaderContent from './HeaderContent';
import styles from './HeaderSupLink.module.scss';;


type Props = {
  linkPath: ?string,
  children: Node,
  className?: string,
}


const HeaderSupLink = ({ linkPath, children, className }: Props) => (linkPath
  ? <HeaderContent className={classNames(styles.root, className)}>
    <Link className={styles.link} to={linkPath}>
      {children}
    </Link>
  </HeaderContent>
  : null
);

export default HeaderSupLink;
